const withUrlParams = (
  url: string,
  params: Record<string, string | number>
): string =>
  Object.entries(params).reduce(
    (url, [key, value]) =>
      url.replace(`:${key}`, encodeURIComponent(String(value))),
    url
  );

export default withUrlParams;
